import React from 'react';

import SectionPitch from './Pitch/Pitch';
import bgimg from './img/bg.jpg';
import styled from 'styled-components';
import {navbarHeight} from "../../utils/sizes";

const Masthead = styled.header`
    // TODO change the background
    background: 
                linear-gradient(to left,#F4F5F7,#F4F5F7);
                min-height: 100vh;
                display: flex;
                flex-direction: column;
    // background: linear-gradient(
    //             to right,
    //             rgba(112, 0, 228, 0.75), 
    //             rgba(0, 0, 0, 0.09)
    //             ),
    //             url(${bgimg});
    //             height: 100vh;
    //@media (max-width: 1000px) {
    //  height: 90vh;
    //}
    @media (max-width: 800px) {
      min-height: 100vw;
        //margin: 0 4em;
        //text-align: center;
    }
`;

const Spacer = styled.div`
    min-height: ${navbarHeight}px;
`

const header = () => {
    return (
        <Masthead>
        <Spacer />
        <SectionPitch />
        </Masthead>
    )
};

export default header;


// WEBPACK FOOTER //
// ./src/components/Masthead/Masthead.jsx